module["exports"] = [
  "com",
  "net",
  "biz",
  "ch",
  "de",
  "li",
  "at",
  "ch",
  "ch"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de_CH/internet/domain_suffix.js
 ** module id = 389
 ** module chunks = 0
 **/